import { GridCellProps } from '@progress/kendo-react-grid';
import { MouseEvent, useCallback } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { stopPropagation } from 'src/utils';

const SupplierEmailCell = (props: GridCellProps) => {
  const { displayValue } = useGridCellDisplayValue(props);
  const email = displayValue.trim();

  const handleClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    stopPropagation(event);
  }, []);

  if (!email) {
    return <GridCellBase {...props}>{displayValue}</GridCellBase>;
  }

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" title={email}>
      <a
        href={`mailto:${email}`}
        className="!text-info hover:underline focus:outline-2 focus:outline-black rounded text-left truncate w-[100%] inline-block"
        onClick={handleClick}
      >
        {email}
      </a>
    </GridCellBase>
  );
};

export default SupplierEmailCell;
